import { useState, useCallback } from 'react';
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  Button,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@leadsnavi/ui-kit';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { SettingSchema, SettingDetail } from '../dto/setting.dto';

export default function Settings() {
  const [loading, setLoading] = useState(false);

  const form = useForm<SettingDetail>({
    resolver: zodResolver(SettingSchema),
    mode: 'onBlur',
    defaultValues: {
      language: 'english',
      currency: 'usd',
    },
    shouldFocusError: true, // 自动聚焦到第一个错误字段
    // criteriaMode: 'firstError', // 或 "all"
  });

  const onSubmit = useCallback(async (data: SettingDetail) => {
    console.log('Form Data:', data);
    try {
      setLoading(true);
      // 模拟异步操作，例如 API 请求
      await new Promise(resolve => setTimeout(resolve, 2000));
      // 提交成功后的逻辑处理
      console.log('Settings updated successfully');
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <div className="py-4 px-5">
      <Form {...form}>
        <div className="flex gap-3 items-start">
          <div className="flex-1">
            <FormField
              control={form.control}
              name="language"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Language</FormLabel>
                  <FormControl>
                    <Select {...field} onValueChange={field.onChange} disabled>
                      <SelectTrigger className="w-full">
                        <SelectValue placeholder="Select a language" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="english">English</SelectItem>
                        <SelectItem value="spanish">Spanish</SelectItem>
                      </SelectContent>
                    </Select>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>

          <div className="flex-1">
            <FormField
              control={form.control}
              name="currency"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Currency</FormLabel>
                  <FormControl>
                    <Select {...field} onValueChange={field.onChange} disabled>
                      <SelectTrigger className="w-full">
                        <SelectValue placeholder="Select a currency" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="usd">USD-US Dollar</SelectItem>
                      </SelectContent>
                    </Select>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </div>
      </Form>

      <div className="flex justify-end space-x-2 pt-8 hidden">
        <Button size="lg" onClick={form.handleSubmit(onSubmit)} loading={loading}>
          Save
        </Button>
      </div>
    </div>
  );
}
